// @flow
import { schemaWeak } from '../passwordValidation';

export const password = (errorMessage: string) => (
  (value: string) => (
    !schemaWeak.validate(value)
      ? errorMessage
      : undefined
  )
);
